export default __webpack_public_path__ + "static/media/alain_back_group_.70965b62.png";